import { Text, Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const AttributesContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: var(--cl-space-2);
  flex: 1 0 0;
`;

export const AttributesHeader = styled(Text)`
  border-bottom: 1px solid var(--cl-gray-400);
  padding: var(--cl-space-2) var(--cl-space-4);
`;

export const AttributeItem = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: var(--cl-space-4);
  &:nth-of-type(even) {
    background-color: var(--cl-gray-100);
  }
`;

export const AttributeName = styled(Text)`
  flex: 0 0 140px;
  overflow-x: auto;
  white-space: nowrap;
  padding: var(--cl-space-4) var(--cl-space-2) var(--cl-space-4) var(--cl-space-4);
`;

export const AttributeValue = styled(Text)`
  flex: 1 1 0;
  min-width: 0;
  overflow-x: auto;
  white-space: nowrap;
  padding: var(--cl-space-4) var(--cl-space-2);
`;
